import Vue from 'vue';
import Vuex from 'vuex';
import searchStore from '@/library-store/search-store';
import activityStore from '@/store-modules/activity-store';
import lookupStore from '@/store-modules/lookup-store';
import comparativeStore from '@/store-modules/comparative-store';
import competencyStore from '@/store-modules/competency-store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },

  mutations: {

  },

  actions: {

  },

  modules: {
    searchStore,
    activityStore,
    lookupStore,
    comparativeStore,
    competencyStore,
  },
});
